var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_551_771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.667 60.4444H99.5554C99.5554 66.8444 97.7776 72.8889 94.5776 78.2222L99.911 83.5556C104.178 76.4444 106.311 68.6222 106.667 60.4444Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8888 60.4444V32C88.8888 18.1333 77.511 7.11111 63.6443 7.46666C53.3332 7.46666 43.7332 14.2222 40.5332 24.1778L86.7554 70.4C88.1776 67.2 88.8888 63.6444 88.8888 60.4444Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6002 94.5778L114.134 119.111L119.111 114.133L14.2224 9.24445L9.24463 14.2222L39.1113 44.0889V60.4444C39.1113 74.3111 50.1335 85.3333 64.0002 85.3333C68.6224 85.3333 72.8891 84.2667 76.8002 81.7778L84.6224 89.6C78.578 93.8667 71.4668 96 64.0002 96C44.8002 96.7111 29.1557 81.4222 28.4446 62.5778V60.4444H21.3335C21.6891 82.4889 38.4002 100.978 60.4446 103.111V113.778H49.778C47.6446 113.778 46.2224 115.2 46.2224 117.333C46.2224 119.467 47.6446 120.889 49.778 120.889H78.2224C80.3557 120.889 81.778 119.467 81.778 117.333C81.778 115.2 80.3557 113.778 78.2224 113.778H67.5557V103.111C75.378 102.4 83.2002 99.5556 89.6002 94.5778Z",
    fill: "#1B1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_551_771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteMicIcon);
export default __webpack_public_path__ + "static/media/mute-mic-icon.02c2e053567f3bcfa714526bf4cf5af0.svg";
export { ForwardRef as ReactComponent };